import { combineReducers } from '@reduxjs/toolkit';
import { reducer as calendarReducer } from 'src/slices/calendar';
import { reducer as chatReducer } from 'src/slices/chat';
import { reducer as formReducer } from 'redux-form';
import { reducer as kanbanReducer } from 'src/slices/kanban';
import { reducer as mailReducer } from 'src/slices/mail';
import { reducer as notificationReducer } from 'src/slices/notification';
import { reducer as branchReducer } from 'src/slices/branch';
import { reducer as productReducer } from 'src/slices/product';
import { reducer as posReducer } from 'src/slices/pos';
import { reducer as customerReducer} from 'src/slices/customers';
import { reducer as purchaseReducer } from 'src/slices/purchase';
import { reducer as saleReducer } from 'src/slices/purchase';
import { reducer as weighbridgeReducer } from 'src/slices/weighbridge';
import { reducer as pdfReducer } from 'src/slices/pdf';

const rootReducer = combineReducers({
  calendar: calendarReducer,
  chat: chatReducer,
  form: formReducer,
  kanban: kanbanReducer,
  mail: mailReducer,
  notifications: notificationReducer,
  branches: branchReducer,
  customers: customerReducer,
  products: productReducer,
  pos: posReducer,
  wbn: weighbridgeReducer,
  purchase: purchaseReducer,
  sale: saleReducer,
  pdf: pdfReducer
});

export default rootReducer;
